import { ColorSource, ITextStyle, Sprite, Text, TextStyle, Texture } from "pixi.js";

export class TextWithUnderline extends Text {
    private underline: Sprite;

    public constructor(
        text?: string | number,
        style?: Partial<ITextStyle> | TextStyle,
        anchor: number = 0,
        underlineTopPadding: number = 0,
        underlineHeight: number = 3
    ) {
        super(text, style);
        this.createUnderline(underlineHeight, underlineTopPadding, Array.isArray(style.fill) ? style.fill[0] ?? 0xFFFFFF : style.fill.toString(), anchor);
    }

    private createUnderline(height: number, topPadding: number, color: ColorSource, anchor: number): void {
        this.underline = new Sprite(Texture.WHITE);
        this.underline.tint = color;
        this.underline.anchor.set(anchor, 0);
        this.underline.position.y = this.height + topPadding;
        this.underline.width = this.width;
        this.underline.height = height;
        this.addChild(this.underline);
    };
}